function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

/* eslint-disable react/no-unused-prop-types */

import * as React from 'react';
import PropTypes from 'prop-types';
import SvgButton from "../basic/SvgButton";
import Button from "../basic/Button";
import { StyleSheet, css, color, zIndex, spacing, font } from "../../styles/theme";
import { SvgInfoFilled, SvgCircleWarning, SvgCheckSolid, SvgError, SvgClose } from "../../svg";
import { Motion, spring } from 'react-motion';

// common styles based on type
function getTypeStyles(type) {
  var camelCaseType = type.charAt(0).toUpperCase() + type.slice(1);
  return {
    backgroundColor: color["bg".concat(camelCaseType)],
    border: "1px solid ".concat(color[type])
  };
}
var capitalizeType = function capitalizeType(type) {
  return "".concat(type.charAt(0).toUpperCase()).concat(type.slice(1));
};

// react-motion interpolation styles, see https://github.com/chenglou/react-motion
var defaultMotionStyle = {
  opacity: 1
};
var finalMotionStyle = {
  opacity: spring(0, {
    stiffness: 150
  })
};
var styles = StyleSheet.create({
  Notification: {
    width: '100%',
    padding: '11px',
    // this needs to be hardcoded because of the 1px border
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: zIndex.md,
    fontSize: font.sm,
    lineHeight: font.lg,
    minHeight: font.xxl
  },
  icon: {
    padding: spacing.sm
  },
  message: {
    paddingLeft: spacing.sm,
    flex: 1
  },
  messageNoIcon: {
    paddingLeft: 0,
    flex: 1
  },
  action: {
    padding: "0 ".concat(spacing.sm)
  },
  dismiss: {
    marginLeft: 'auto'
  },
  info: getTypeStyles('info'),
  warning: getTypeStyles('warning'),
  success: getTypeStyles('success'),
  danger: getTypeStyles('danger'),
  error: getTypeStyles('error')
});

// map icon type to component
var ICON_MAP = {
  info: SvgInfoFilled,
  warning: SvgCircleWarning,
  danger: SvgError,
  error: SvgError,
  success: SvgCheckSolid
};

// render action button
var defaultActionRenderer = function defaultActionRenderer(action, onAction) {
  return /*#__PURE__*/React.createElement(Button, {
    type: "link",
    size: "sm",
    label: action,
    onClick: onAction,
    htmlAttributes: {
      'aria-label': action
    }
  });
};

/**
 * A customizable Notification component to show a message with an optional
 * call-to-action and an optional dismiss.
 */
var Notification = /*#__PURE__*/function (_React$Component) {
  function Notification() {
    var _this;
    _classCallCheck(this, Notification);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Notification, [].concat(args));
    _defineProperty(_this, "state", {
      hide: false,
      showTransient: false
    });
    _defineProperty(_this, "renderIcon", function () {
      var _this$props = _this.props,
        type = _this$props.type,
        iconSize = _this$props.iconSize,
        iconTitle = _this$props.iconTitle;
      var Icon = ICON_MAP[type];
      return /*#__PURE__*/React.createElement(Icon, {
        title: iconTitle || capitalizeType(type),
        size: iconSize,
        color: color[type]
      });
    });
    _defineProperty(_this, "renderMessage", function () {
      var _this$props2 = _this.props,
        message = _this$props2.message,
        hideIcon = _this$props2.hideIcon;
      return /*#__PURE__*/React.createElement("span", css(hideIcon ? styles.messageNoIcon : styles.message), message);
    });
    _defineProperty(_this, "startMotion", function () {
      _this.setState({
        showTransient: true
      });
    });
    return _this;
  }
  _inherits(Notification, _React$Component);
  return _createClass(Notification, [{
    key: "renderDismiss",
    value: function renderDismiss() {
      return /*#__PURE__*/React.createElement("div", _extends({
        "data-classname": "notification-dismiss"
      }, css(styles.dismiss)), /*#__PURE__*/React.createElement(SvgButton, {
        type: "link",
        size: "sm",
        onClick: this.props.onDismiss,
        svgElement: /*#__PURE__*/React.createElement(SvgClose, {
          size: 18
        }),
        htmlAttributes: {
          'aria-label': 'Dismiss notification'
        }
      }));
    }
  }, {
    key: "renderComponent",
    value: function renderComponent(styleOverrides) {
      var _this$props3 = this.props,
        htmlAttributes = _this$props3.htmlAttributes,
        style = _this$props3.style,
        type = _this$props3.type,
        isLite = _this$props3.isLite;
      var actionRenderer = this.props.actionRenderer || defaultActionRenderer;
      return /*#__PURE__*/React.createElement("div", _extends({}, htmlAttributes, css(styles.Notification, !isLite && styles[type]), {
        style: Object.assign({}, style, styleOverrides)
      }), !this.props.hideIcon && this.renderIcon(), this.renderMessage(), this.props.action && actionRenderer(this.props.action, this.props.onAction), this.props.isDismissible && this.renderDismiss());
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        isTransient = _this$props4.isTransient,
        onDismiss = _this$props4.onDismiss,
        transientDuration = _this$props4.transientDuration;
      var showTransient = this.state.showTransient;
      if (!isTransient) {
        return this.renderComponent();
      }

      // special animation handling for Transient notifications
      if (!showTransient) {
        // show the regular component for `transientDuration`
        setTimeout(this.startMotion, transientDuration);
        return this.renderComponent();
      } else {
        // wrap in Motion component to trigger animation
        return /*#__PURE__*/React.createElement(Motion, {
          defaultStyle: defaultMotionStyle,
          style: finalMotionStyle
        }, function (_ref) {
          var opacity = _ref.opacity;
          if (opacity === 0 && onDismiss) {
            // notify client that notification is hidden
            // so they can choose to take some action, like unmount it
            onDismiss();
          }

          // pass interpolated opacity override to animate over
          return _this2.renderComponent({
            opacity: opacity
          });
        });
      }
    }
  }]);
}(React.Component);
_defineProperty(Notification, "propTypes", {
  type: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'error']),
  // used to infer colors and icon
  icon: PropTypes.node,
  // customized icon,
  iconTitle: PropTypes.string,
  iconSize: PropTypes.number,
  // size of icon in px
  hideIcon: PropTypes.bool,
  header: PropTypes.node,
  // we may need to display a title or some timestamps on top
  content: PropTypes.node,
  // body of notification (we can use Expandable/TextTruncate)
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  // notification message
  isDismissible: PropTypes.bool,
  // whether to allow dismissing the notification
  onDismiss: PropTypes.func,
  // callback when notification is dismissed, or hidden (for transient notifications)
  dismissAfter: PropTypes.number,
  // time in milliseconds to wait before dismissing notification
  action: PropTypes.node,
  // CTA node for the notification
  onAction: PropTypes.func,
  // callback for CTA node
  actionRenderer: PropTypes.func,
  // rendering an action component, pass in a render function (action, onAction) => {} for custom rendered buttons e.g. TrackedButton, SplitButton

  /* eslint-disable react/forbid-prop-types */
  htmlAttributes: PropTypes.object,
  style: PropTypes.object,
  // Override the inline-styles of the root element
  /* // eslint-enable react/forbid-prop-types */

  isThemeDark: PropTypes.bool,
  isLite: PropTypes.bool,
  // lite version of notification, with minimum styling

  isTransient: PropTypes.bool,
  // transient notifications will hide themselves after `transientDuration`,
  transientDuration: PropTypes.number // milliseconds to show transient notification for before hiding
});
_defineProperty(Notification, "defaultProps", {
  type: 'info',
  htmlAttributes: {},
  style: {},
  hideIcon: false,
  iconSize: 24,
  message: '',
  isDismissible: false,
  isTransient: false,
  action: null,
  isThemeDark: false,
  isLite: false,
  transientDuration: 4000
});
export default Notification;